const BIZ_TYPE_KEYS = {
  CLIENTS: {
      service_provider: "CLIENTS",
      maintenance_department: "REPORTING_DEPARTMENTS",
      hotel: "CLIENTS",
    },
    CLIENT: {
      service_provider: "CLIENT",
      maintenance_department: "REPORTING_DEPARTMENT",
      hotel: "ROOM",
    },
    SELECT_CLIENT: {
      service_provider: "SELECT_CLIENT",
      maintenance_department: "SELECT_DEPARTMENTS",
      hotel: "SELECT_ROOM",
    },
    ADDR: {
      service_provider: "ADDR",
      maintenance_department: "LOCATION",
      hotel: "LOCATION",
    },
    COMPANY: {
      service_provider: "COMPANY",
      maintenance_department: "DEPARTMENT_NAME",
      hotel: "COMPANY",
    },
    IS_BLOCKED: {
      service_provider: "IS_BLOCKED",
      maintenance_department: "IS_DEPARTMENT_BLOCKED",
      hotel: "IS_BLOCKED",
    },
    CLIENT_GUID: {
      service_provider: "CLIENT_GUID",
      maintenance_department: "DEPARTMENT_CLIENT_GUID",
      hotel: "CLIENT_GUID",
    },
    NEW_CLIENT: {
      service_provider: "NEW_CLIENT",
      maintenance_department: "NEW_REPORTING_DEPARTMENT",
      hotel: "NEW_CLIENT",
    },
  }
  export default BIZ_TYPE_KEYS